import { useContext, useReducer, createContext, useCallback } from "react";
import { useRequest } from "../../services/request";

const Context = createContext();

export function useWhatsAppNumber() {
  return useContext(Context);
}

const initState = {
  list: [],
  selected: null,
  status: "idle",
  error: null,
};
const reducer = (state, action) => {
  switch (action.type) {
    case "set_list":
      return { ...state, list: [...action.payload] };
    case "set_selected":
      return { ...state, selected: { ...action.payload } };
    case "add":
      const newList = [{ ...action.payload }, ...state.list];
      return { ...state, list: newList };
    case "edit":
      const modified = state.list.map((p) =>
        p.id === action.payload.id ? { ...p, ...action.payload } : p
      );
      return { ...state, list: modified };
    case "delete":
      const filtered = state.list.filter((p) => p.id !== action.payload);
      return { ...state, list: filtered };
    case "addNumber":
      const newSelected = {
        ...state.selected,
        numbers: [...state.selected.numbers, action.payload],
      };
      return { ...state, selected: newSelected };
    case "editNumber": {
      if (!state.selected?.numbers) return state; // Early return if no numbers exist
      console.log(action.payload, "pp");

      const updatedNumbers = state.selected?.numbers?.map((number) =>
        number.id === action.payload.id
          ? { ...number, ...action.payload }
          : number
      );
      return {
        ...state,
        selected: {
          ...state.selected,
          numbers: updatedNumbers,
        },
      };
    }
    case "deleteNumber":
      const filteredNumber = state.selected?.numbers.filter(
        (p) => p.id !== action.payload
      );
      return {
        ...state,
        selected: { ...state.selected, numbers: filteredNumber },
      };
    case "status":
      return { ...state, status: action.payload };
    default:
      throw new Error(`Invalid dispatch type: ${action.type}`);
  }
};

export default function WhatsAppNumberProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initState);
  const req = useRequest();

  const fetchList = useCallback(async () => {
    dispatch({ type: "status", payload: "fetching" });
    const resData = await req(`WhatsAppAccount/List`, null, {}, true);
    dispatch({ type: "status", payload: `idle` });
    dispatch({ type: "set_list", payload: resData.data || [] });
  }, [req]);

  const fetchOne = useCallback(
    (id) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `fetching` });
        const resData = await req(`WhatsAppAccount/Info/${id}`, null, {}, true);
        dispatch({ type: "set_selected", payload: resData.data });
        dispatch({ type: "status", payload: `idle` });
        resolve(resData);
      });
    },
    [req]
  );

  const create = useCallback(
    async (data) => {
      return new Promise(async (resolve, reject) => {
        try {
          const newData = { ...data };
          const resData = await req(
            "WhatsAppAccount/Add",
            newData,
            { method: "POST" },
            true
          );
          dispatch({ type: "add", payload: resData.data });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req]
  );

  const edit = useCallback(
    async (id, data) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `creating` });
        try {
          const resData = await req(
            `WhatsAppAccount/Update/${id}`,
            data,
            { method: "PUT" },
            true
          );
          dispatch({ type: "edit", payload: resData.data });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req]
  );

  const remove = useCallback(
    async (id) => {
      return new Promise(async (resolve, reject) => {
        try {
          const resData = await req(
            `WhatsAppAccount/Delete/${id}`,
            null,
            { method: "DELETE" },
            true
          );
          dispatch({ type: "delete", payload: id });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req]
  );
  {
    /** For whatsApp Number Controller */
  }

  const AddNumber = useCallback(
    async (id, data) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `creating` });
        try {
          const resData = await req(
            `WhatsAppAccount/AddNumber/${id}`,
            data,
            { method: "PUT" },
            true
          );
          dispatch({ type: "addNumber", payload: resData.data });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req]
  );
  const editNumber = useCallback(
    async (id, data) => {
      return new Promise(async (resolve, reject) => {
        dispatch({ type: "status", payload: `creating` });
        try {
          const resData = await req(
            `WhatsAppAccount/UpdateNumber/${id}`,
            data,
            { method: "PUT" },
            true
          );
          dispatch({ type: "editNumber", payload: resData.data });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req]
  );

  const removeNumber = useCallback(
    async (id) => {
      return new Promise(async (resolve, reject) => {
        try {
          const resData = await req(
            `WhatsAppAccount/DeleteNumber/${id}`,
            null,
            { method: "DELETE" },
            true
          );
          dispatch({ type: "deleteNumber", payload: id });
          resolve(resData);
        } catch (e) {
          reject(e);
        } finally {
          dispatch({ type: "status", payload: `idle` });
        }
      });
    },
    [req]
  );

  return (
    <Context.Provider
      value={{
        state,
        fetchList,
        fetchOne,
        edit,
        create,
        remove,
        AddNumber,
        editNumber,
        removeNumber,
        dispatch,
      }}
    >
      {children}
    </Context.Provider>
  );
}
